<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18UrNOr/tc-custom/9781466858473.jpg?1726483263318" alt="This image is the cover for the book Last Plane to Heaven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Plane to Heaven
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Last Plane to Heaven</i> is the final and definitive short story collection of award-winning SF author Jay Lake, author of <i>Green</i>, <i>Endurance</i>, and <i>Kalimpura</i>. <br/><br/>Long before he was a novelist, SF writer Jay Lake, was an acclaimed writer of short stories.  In <i>Last Plane to Heaven</i>, Lake has assembled thirty-two of the best of them. Aliens and angels fill these pages, from the title story, a hard-edged and breathtaking look at how a real alien visitor might be received, to the savage truth of "The Cancer Catechisms." Here are more than thirty short stories written by a master of the form, science fiction and fantasy both.<br/><br/>This collection features an original introduction by Gene Wolfe.<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jay Lake, Gene Wolfe
      </h2>
      
      <p class="authorDescription body article">JAY LAKE was a prolific writer of science fiction and fantasy, as well as an award-winning editor, a popular raconteur and toastmaster, and an excellent teacher at the many writers' workshops he attended.  His novels included Tor's publications <I>Mainspring</I>, <I>Escapement</I>, and <I>Pinion</I>, and the trilogy of novels in his Green cycle - <I>Green</I>, <I>Endurance</I> and <I>Kalimpura</I>. Lake was nominated multiple times for the Hugo Award, the Nebula Award, and the World Fantasy Award. He won the John W. Campbell Award for best new writer in 2004, the year after his first professional stories were published.  In 2008 Jay Lake was diagnosed with colon cancer, and in the years after he became known outside the sf genre as a powerful and brutally honest blogger about the progression of his disease.  Jay Lake died on June 1, 2014.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e6224936